import axiosRequest from '@/libs/axios';

/**
 *  @description: 系统业务功能全部接口
 *  @time: 2022-06-13 18:46:13
 */

export default {
  /** 用户信息 */
  company_getInfo: (data) => {
    return axiosRequest.get('getInfo', data);
  },
  /** 退出登录 */
  logout: () => {
    return axiosRequest.post("logout");
  },
  /** 全部路由 */
  getRouters: () => {
    return axiosRequest.get("getRouters");
  },
  /** 获取验证码 */
  getCaptchaUrl: () => {
    return axiosRequest.get("getCaptchaUrl", {}, false);
  },
  /** 登录 */
  company_login: (data) => {
    return axiosRequest.post("login", data);
  },
  /** 文件上传 */
  getUploadInfo (data) {
    return axiosRequest.get('getOssSign', data,false)
  }
}
